export const PERF_PROBE_LEVEL = Object.freeze({
  High: 'high',
  Medium: 'medium',
  Low: 'low',
} as const)

export type PerfProbeLevel =
  (typeof PERF_PROBE_LEVEL)[keyof typeof PERF_PROBE_LEVEL]

export type PerfProbeReason =
  | 'benchmark'
  | 'memory-below-6gb'
  | 'software-renderer'
  | 'legacy-windows'
  | 'worker-unavailable'
  | 'worker-timeout'
  | 'apple-device-cap'

export interface PerfProbeReport {
  readonly probeVersion: string
  readonly level: PerfProbeLevel
  readonly frames: number
  readonly elapsedMs: number
  readonly renderer?: string
  readonly deviceMemoryGb: number | null
  readonly reason: PerfProbeReason
  readonly measuredAt: number
}

export interface AppleDeviceMatch {
  readonly matched: boolean
  readonly viewportKey: string
  readonly skus: readonly string[]
  readonly marketingNames: readonly string[]
  readonly ramGb: number | null
  readonly maxLevel: PerfProbeLevel | null
  readonly chip?: string
  readonly ambiguous: boolean
}

export type DeviceClassKind = 'phone' | 'tablet' | 'desktop' | 'unknown'

export interface DeviceClassInfo {
  readonly kind: DeviceClassKind
  readonly reason: string
  readonly viewportKey: string | null
  readonly dpr: number | null
}

export interface GpuBenchmarkResult {
  readonly frames: number
  readonly elapsedMs: number
  readonly error?: 'worker-unavailable' | 'worker-timeout'
}

export interface RunPerfProbeOptions {
  readonly force?: boolean
}

export interface BenchmarkWorkerPayload {
  readonly canvas: OffscreenCanvas
  readonly durationMs: number
}

export interface BenchmarkWorkerResult {
  readonly frames: number
  readonly elapsedMs: number
  readonly error?: string
}
